import { useState, useEffect } from "react";
import { Modal } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";

import { Modals } from "scripts/settings";
import Resources from "scripts/resources";
import { GetUrlParams, ObjectToURL } from "scripts/helpers";

const Component = ({ categories = [] }) => {
	const initialState = { shownCategories: categories, visible: false };
	const [state, setState] = useState(initialState);
	const { visible, shownCategories } = state;
	const location = useLocation();
	const navigate = useNavigate();
	const { coordinates, search, sortBy } = GetUrlParams(location.search);
	const categoryQuery = ObjectToURL({ coordinates, search, sortBy });

	// const shownCategories = parentId
	// 	? categories.filter((o) => o.parentId === `${parentId}`)
	// 	: categories.filter((o) => o.hasChild === true)

	const parentId = parseInt(location.hash?.split("_")[1]) || null;

	const componentDidUpdate = () => {
		if (location.hash?.startsWith(`#${Modals.CATEGORY}`)) {
			setState((prevState) => ({
				...prevState,
				shownCategories: parentId
					? categories.filter((o) => o.parentId === parentId)
					: categories.filter((o) => o.hasChild === true),
				visible: true,
			}));
		} else {
			setState(initialState);
		}
	};

	useEffect(componentDidUpdate, [location.hash]);

	return (
		<Modal
			className="bk-modal-category"
			footer={false}
			maskClosable={false}
			onCancel={() => navigate(-1)}
			open={visible}
			width={500}
			destroyOnClose
			title={Resources.category}
		>
			<ul className="list">
				{shownCategories?.map((o) => (
					<li
						key={o.id}
						className={o.hasChild ? "has-child" : ""}
					>
						<Link
							to={
								o.hasChild
									? `${location.search}#${Modals.CATEGORY}_${o.id}`
									: `/jobs?category=${o.id}${
											categoryQuery && `&${categoryQuery}`
									  }`
							}
						>
							<img
								src={o.icon}
								alt={o.title}
							/>
							{o.title}
						</Link>
					</li>
				))}
			</ul>
		</Modal>
	);
};

export default connect((state) => {
	return {
		categories: state.categories,
	};
})(Component);
